<template>
  <v-card flat fill-height style="height:100%;">
    <v-card-title v-if="!!cardData && cardData['canNav']" style="height:10%;cursor:pointer;" v-on:click="navTo()" v-on:mouseleave="color='rgb(95,158,239)'" v-on:mouseover="color='rgb(51,82,128)'">
      <div primary class="title" :style="'color:'+color+';'">{{ title }}</div>
      <v-icon :color="color">play_arrow</v-icon>
    </v-card-title>
    <v-card-title v-else style="height:10%;">
      <div primary class="title">{{ title }}</div>
<!--      <v-icon>play_arrow</v-icon>-->
    </v-card-title>
    <v-card-actions fill-height style="height:90%;">
      <v-container v-if="!!cardData" fluid fill-height grid-list-md style="padding:5px;">
        <v-layout column fill-height>
          <v-flex d-flex md6 style="max-height:50%;">
            <v-layout row>
              <v-flex d-flex md4>
                <Card v-if="typeof cardData != 'undefined'" :cardData="cardData['pcomp']"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-if="typeof cardData != 'undefined'" :cardData="cardData['tcspeed']"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-if="typeof cardData != 'undefined'" :cardData="cardData['pscav']"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md6 style="max-height:50%;">
            <v-layout row>
              <v-flex d-flex md4>
                <Card v-if="typeof cardData != 'undefined'" :cardData="cardData['pmax']"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-if="typeof cardData != 'undefined'" :cardData="cardData['bsfc']"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-if="typeof cardData != 'undefined'" :cardData="cardData['tTurbIn']"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>

import Card from './Card'
import Gauge from './Gauge'

import {globalStore} from "../main.js"

export default {
  name: "PerformanceWidget",
  components: {
    Card,
    Gauge
  },
  props: {
    cardData: Object,
    gaugeData: Object,
    title: String,
    engine: String
  },
  data: function () {
    return {
      color: 'rgb(95,158,239)'
    }
  },
  methods: {
    navTo() {
      if (globalStore.twinEngine) {
        globalStore.faults = globalStore.twinFaults[this.engine];
        globalStore.signals = globalStore.twinSignals[this.engine];
        globalStore.reference = globalStore.twinReference[this.engine];
        globalStore.selectedEngine = this.engine;

        this.$router.push( { name:  'Engine Performance' , params:{'vessel':this.$route.params.vessel, 'eng':this.engine}} )
      } else {
        this.$router.push( { name:  'Engine Performance' , params:{'vessel':this.$route.params.vessel}} )
      }
    }
  },
  mounted() {
  },
  watch: {}
}
</script>

<style scoped>
</style>